<template>
	<v-dialog :fullscreen="isMobile" v-if="shareModalOpen" v-model="shareModalOpen" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title class="headline modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="shareModalOpen=false"><v-icon large>fal fa-times</v-icon></button>
			</v-card-title>
			<v-card-text class="modal__card-text basic-modal-padding pt-0">
				<div>
					<div class="text-xs-center hidden-xs-only">
						<i class="info--text fal fa-users" style="font-size: 4.8em;"></i>
					</div>
					<div style="font-size: 1.4em;" class="info--text">
						Share this with a friend or two!
					</div>
					<div>
						WRKPRTY events are always even better when friends see friends and get a chance to connect a bit around work. Don’t be shy, they’ll thank you.
					</div>

					<div class="mt-4">
						<span class="success--text">Option 1:</span> Copy and paste this event link and share it directly - any way you can (email, text message, etc.)
					</div>
					<div class="mt-4 mb-4 text-xs-center">
						<input type="text" ref="eventUrlInput" v-model="eventURL" class="yellow"> &nbsp; <a @click="copyEventLink">copy</a>
					</div>
					<div class="mb-4">
						<span class="success--text">Option 2:</span> Click the button to share with friends on any of these platforms:
					</div>
					<div @click="clickShareSocial">
						<social-sharing
							:url="eventURL"
							:title="event.title"
							description="WRKPRTY is a new social coworking events site."
							quote="Check out this social coworking event I'm going to!"
							hashtags="wrkprty,workparty,coworking"
							twitter-user="wrkprty"
							network-tag="a"
							inline-template
						>
							<ul class="list-unstyled list-inline social-icons icon-circle icon-rotate text-xs-center">
								<li>
									<network network="facebook">
										<i class="fab fa-facebook-f"></i>
									</network>
								</li>
								<li>
									<network network="twitter">
										<i class="fab fa-twitter"></i>
									</network>
								</li>
								<li>
									<network network="googleplus">
										<i class="fab fa-google-plus-g"></i>
									</network>
								</li>
								<li>
									<network network="skype">
										<i class="fab fa-skype"></i>
									</network>
								</li>
								<li>
									<network network="telegram">
										<i class="fab fa-telegram-plane"></i>
									</network>
								</li>
								<li>
									<network network="linkedin">
										<i class="fab fa-linkedin-in"></i>
									</network>
								</li>
								<!-- <li class="hidden-sm-and-up">
									<network network="whatsapp">
										<i class="fab fa-whatsapp"></i>
									</network>
								</li> -->
								<li>
									<network network="pinterest">
										<i class="fab fa-pinterest-p"></i>
									</network>
								</li>
								<li>
									<network network="sms">
										<i class="fal fa-comment-alt"></i>
									</network>
								</li>
							</ul>
						</social-sharing>
					</div>
					<div class="mt-4 mb-4">
						<span class="success--text">Option 3:</span> Enter a friend's email below and we'll send them a special invitation on your behalf.
					</div>
					<div style="display: flex; flex-direction: row; justify-content: space-between;">
						<v-text-field solo v-model="inviteFriendEmail" placeholder="Friend's email :)" :rules="emailRules" style="flex-grow: 4"></v-text-field>
						<v-btn large @click="inviteFriend" color="success" :disabled="!inviteFriendEmail" :loading="submitting">Send</v-btn>
					</div>
				</div>
				<div v-if="!isMobile">
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'shareModal',
	data() {
		return {
			submitting: false,
			windowURL: window.location.origin,
			inviteFriendEmail: null,
			emailRules: [
				v => !!v || 'E-mail is required',
				v =>
					/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(v) ||
					'E-mail must be valid'
			]
		}
	},
	methods: {
		...mapActions(['setModalOpen', 'setSnackbarOpen', 'setSnackbarText']),
		clickShareSocial() {
		},
		inviteFriend() {
			this.submitting = true
			axios
				.post('/api/v1/contact/', {
					name: this.user.first_name + ' ' + this.user.last_name,
					subject: 'Invite Friend to wrkprty',
					event: this.event.pk,
					message:
						'Send invite to ' +
						this.inviteFriendEmail +
						' on behalf of ' +
						this.user.first_name +
						' ' +
						this.user.last_name,
					email: this.user.email
				})
				.then(response => {
					this.submitting = false
					this.inviteFriendEmail = ''
					this.setSnackbarText('Invite Sent! Try sending another!')
					this.setSnackbarOpen(true)
				})
				.catch(error => {
					console.error(error)
				})
		},
		copyEventLink() {
			this.$refs.eventUrlInput.select()
			try {
				var successful = document.execCommand('copy')
				var msg = successful ? 'successful' : 'unsuccessful'
				console.log('Copying text command was ' + msg)
			} catch (err) {
				console.log('Oops, unable to copy')
			}
		}
	},
	computed: {
		...mapGetters([
			'userIsAuthenticated',
			'user',
			'getModalProp',
			'getShareModalEvent',
			'getModalProp'
		]),
		shareModalOpen: {
			get() {
				return this.getModalProp('shareModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'shareModal', value: val })
			}
		},
		event() {
			return this.getShareModalEvent
		},
		eventURL() {
			return this.windowURL + '/events/' + this.event.slug
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>

<style>
.padding {
	padding: 26px;
}

@media screen and (max-width: 600px) {
	.padding {
		padding: 10px;
	}
}
</style>
